import { truncateTimeZoneDate } from './dates';
import { valueToNull, valueToNumber, valueToString } from './format';

export const parseCreateSpotQuoteDataFromFormData = (data) => {
  return {
    quoteNo: valueToString(data?.quoteNo),
    quoteTitle: valueToString(data?.quoteTitle),
    status: valueToString(data?.status),
    currencyCode: valueToString(data?.currencyCode),
    totalCube: valueToString(data?.totalCube),
    totalUnits: valueToString(data?.totalUnits),
    totalWeight: valueToString(data?.totalWeight),
    quoteDetails: data?.products?.map((row) => ({
      productCode: valueToString(row?.productCode),
      productDescription: valueToString(row?.productDescription),
      quantity: valueToNumber(row?.quantity),
      weight: valueToNumber(row?.weight),
      weightUom: valueToString(row?.weightUom),
      length: valueToNumber(row?.length),
      width: valueToNumber(row?.width),
      height: valueToNumber(row?.height),
      dimUom: valueToString(row?.dimUom),
      cube: valueToNumber(row?.cube),
      hazardousClass: valueToString(row?.hazardousClass),
      harmonizedCode1: valueToString(row?.harmonizedCode1),
      harmonizedCode2: valueToString(row?.harmonizedCode2),
    })),
    transportationDetails: data?.stops?.map((row) => ({
      stopTypeId: valueToString(row?.stopTypeId),
      stopSequence: valueToNumber(row?.stopSequence),
      countryCode: valueToString(row?.countryCode),
      portCity: valueToString(row?.portCity),
      portState: valueToString(row?.portState),
      portName: valueToString(row?.portName),
      portType: valueToString(row?.portType),
      portRecKey: valueToNull(row?.portRecKey),
      address: valueToString(row?.address),
    })),
    transportationMode: valueToString(data?.transportationMode),
    distance: valueToNumber(data?.distance),
    transportationGroup: valueToString(data?.transportationGroup),
    shipDate: truncateTimeZoneDate(data?.shipDate?.set({ hour: 12, minute: 0, second: 0 })),
    incoterms: valueToString(data?.incoterms),
    psl: valueToString(data?.psl),
    shipment: valueToString(data?.shipment),
    urgency: valueToString(data?.urgency),
    deliveryDate: truncateTimeZoneDate(data?.deliveryDate?.set({ hour: 12, minute: 0, second: 0 })),
    incotermnamedPlace: valueToString(data?.incotermnamedPlace),
    ami: valueToString(data?.ami),
    po: valueToString(data?.po),
    quoteNotes: valueToString(data?.quoteNotes),
    bidExpirationTimeZoneInfo: data.bidExpirationTimeZoneInfo,
    bidExpirationOffsetHours: data.bidExpirationOffsetHours,
    bidExpirationDate: truncateTimeZoneDate(data?.bidExpirationDate),
  };
};
